'use client';

import React from 'react';

import { Link } from '@/i18n/routing';

type StaticFooterItemProps = {
    children?: React.ReactNode;
    href?: string;
    onClick?: () => void;
};

export default function StaticFooterItem(props: StaticFooterItemProps) {
    return (
        <div className="my-8 xl:my-0">
            {props.href ? (
                <Link
                    className="flex-auto clickable-element text-center sm:text-left"
                    href={props.href}
                    onClick={props.onClick}>
                    {props.children}
                </Link>
            ) : (
                <div
                    className="flex-auto clickable-element text-center sm:text-left"
                    {...props}>
                    {props.children}
                </div>
            )}
        </div>
    );
}
